import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { addNewFavorite } from '../../actions/favorites_actions';
import { fetchInventoryBatches } from '../../actions/wholesaleModal_actions';

import WholesaleModal from '../../components/Sales/wholesaleModal';

let wholesaleModal = reduxForm({
    form: 'wholesaleModal',
})(WholesaleModal);

function mapStateToProps(state) {
    return {
        inventoryBatches: state.wholesaleModal.all,
        isLoading: state.wholesaleModal.isLoading,
        error: state.wholesaleModal.error
    }
}

export default connect(mapStateToProps, {fetchInventoryBatches})(wholesaleModal);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/wholesaleModal.jsx